export default "__VITE_ASSET__BCSk4VTc__"